import React, { useContext, useEffect, useState } from 'react';
import useQueries from '../../../../database/useQueries';
import { useIndexedDBSyncV2 } from '../../../../database/dataLocal/indexedDBHooks';
import PageDocumentsGrave from './PageDocumentsGrave';
import useDocManager from '../../../../database/documents/docManager';
import { format } from 'date-fns';
import { mapFieldValues } from '../utility';
import { useSelector } from 'react-redux';
import MyGenericComponent from './documentsDetails';
import LoadingOverlay from '../../pagesMains/LoadingOverlay';
import { Typography } from '@mui/material';
import CustomDialog from '../dialogs/customDialog';
import { DataContext } from '../../pagesMains/GravesManagers/Graves';
import { createFetchDataServer } from '../../../../database/fetchData';
import hebrewDate from '../hebrewDate';

const GraveDocuments = ({ grave, purchase, purchaseContent, burialContent }) => {

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [openCertificate, setOpenCertificate] = useState(false);

  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data)

  const { getEntityByAttr } = useQueries();

  const { docConsular, docDeep, docPurchase, docBurial } = useDocManager();

  const [areaGrave, setAreaGrave] = useState(getEntityByAttr(context?.contextAreaGraves, 'gravesList', grave?.areaGraveId));
  const [row, setRow] = useState(getEntityByAttr(context?.contextRows, 'unicId', areaGrave?.lineId));
  const [plot, setPlot] = useState(getEntityByAttr(context?.contextPlots, 'unicId', areaGrave?.plotId));
  const [block, setBlock] = useState(getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId));
  const [cemetery, setCemetery] = useState(getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId));

  // const [purchase, setPurchases] = useState(getEntityByAttr(context?.purchases, 'graveId', grave?.unicId));
  const [customer, setCustomer] = useState(mapFieldValues([getEntityByAttr(context?.contextCustomers, 'unicId', purchase?.clientId)], optionsFields)[0]);
  const [contact, setContact] = useState(getEntityByAttr(context?.contextCustomers, 'unicId', purchase?.contactId));
  const [country, setCountry] = useState(getEntityByAttr(context?.contextCountries, 'unicId', customer?.countryId));
  const [city, setCity] = useState(getEntityByAttr(context?.contextCities, 'unicId', customer?.cityId));

  // const [city, setCity] = useState(getEntityByAttr(context?.contextCities, 'unicId', customer?.cityId));

  useEffect(() => {
    setCustomer(mapFieldValues([getEntityByAttr(context?.contextCustomers, 'unicId', purchase?.clientId)], optionsFields)[0])
    setBlock(getEntityByAttr(context?.contextBlocks, 'unicId', grave?.blockId))
    setPlot(getEntityByAttr(context?.contextPlots, 'unicId', grave?.plotId))
    setCity(getEntityByAttr(context?.contextCities, 'unicId', customer?.cityId))
    setCountry(getEntityByAttr(context?.contextCountries, 'unicId', customer?.countryId))
  }, [context]);

  const handleClick = (setIsClicked) => {
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
    }, 100); // העמעום יישאר למשך 100 מילישניות
  };

  function formatNumberWithCommas(number) {
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const handleClickConsular = (id, fileName, setIsClicked) => {
    handleClick(setIsClicked);

    const data = {
      serialNumber: purchase?.serialPurchaseId || '----',
      name: `${(customer?.nom === '' || customer?.nom === undefined) ?
          `${customer?.firstName || ''} ${customer?.lastName || ''}` : customer?.nom}`,
      cemetery: grave?.cemeteryNameEn || '----',
      block: grave?.blockNameEn || '----',
      plot: grave?.plotNameEn || '----',
      row: grave?.lineNameEn || '----',
      grave: grave?.graveNameHe !== '' ? `${areaGrave?.areaGraveNameHe}-${grave?.graveNameHe}` : `${areaGrave?.areaGraveNameHe}`,
      deep: purchase?.deedNum || '----',
    };

    const document = 'consular';

    docConsular(data, document, fileName);
  };

  const handleClickPurchase = (id, fileName, setIsClicked) => {
    handleClick(setIsClicked);

    const countGraves = context?.contextGraves?.filter( e=> e?.areaGraveId === grave?.areaGraveId )?.length
    const nameGrave = countGraves?.length > 1 ? 
        `${grave?.areaGraveNameHe}-${grave?.graveNameHe}`?.toString() || '':
        `${grave?.graveNameHe}`?.toString() || ''

    // בדיקה אם dateBirth קיים ואם הוא תאריך תקף
    let formattedDateBirth = '';
    if (customer?.dateBirth) {
      const date = new Date(customer?.dateBirth);
      if (!isNaN(date.getTime())) { // בדיקה אם התאריך תקף
        formattedDateBirth = format(date, 'dd/MM/yyyy');
      }
    }

    const data = {
      serialNumber: purchase?.serialPurchaseId || '1234',

      lastName: customer?.lastName?.toString() || '',
      nameFather: customer?.nameFather?.toString() || '',
      gender: customer?.gender?.toString() || '',

      firstName: customer?.firstName?.toString() || '',
      nameMother: customer?.nameMother?.toString() || '',
      maritalStatus: customer?.maritalStatus?.toString() || '',

      numId: customer?.numId?.toString() || '',
      dateBirth: formattedDateBirth,
      association: customer?.association?.toString() || '',

      oldName: customer?.oldName?.toString() || '',
      dateBirthHe: customer?.dateBirthHe?.toString() || '',

      contactName: contact ? `${contact?.firstName} ${contact?.lastName}` : '',
      contactId: contact?.numId?.toString() || '',

      kinship: purchase?.kinship?.toString() || '',
      contactPhone: contact?.phone?.toString() || '',
      contactPhoneMobile: contact?.phoneMobile?.toString() || '',

      noData: customer?.noData?.toString() || 'noData',


      address: customer?.address?.toString() || '',
      city: city?.cityNameHe?.toString() || '',
      country: country?.countryNameHe?.toString() || '',

      phone: customer?.phone?.toString() || '',
      phoneMobile: customer?.phoneMobile?.toString() || '',

      cemetery: grave?.cemeteryNameHe?.toString() || '',
      block: grave?.blockNameHe?.toString() || '',
      plot: grave?.plotNameHe?.toString() || '',
      row: grave?.lineNameHe?.toString() || '',
      plotType: grave?.plotType?.toString() || '',
      price: formatNumberWithCommas(purchase?.price)?.toString() || '',
      grave: nameGrave,
      deep: purchase?.serialPurchaseId?.toString() || '',
    };

    const document = 'purchase';

    docPurchase(data, document, fileName);
  };

  const handleClickDeep = (id, fileName, setIsClicked) => {
    if (purchase?.ifCertificate) {
      handleClick(setIsClicked);

      console.log(block.nationalInsuranceCode);
      
      // רוורס לאנגלית
      const reverseString = (str) => {
        return str?.split('').reverse().join('');
      };
      const reverseNonHebrew = (str) => {
        // ביטוי רגולרי שמזהה תווים בעברית
        const containsHebrew = /[\u0590-\u05FF]/;
      
        // אם הטקסט אינו מכיל תווים בעברית, מחזירים אותו כפי שהוא
        if (!containsHebrew.test(str)) {
          return str;
        }
      
        // ביטוי רגולרי שמפריד בין עברית, רווחים וחלקים אחרים
        const regex = /[\u0590-\u05FF]+|\s+|[^\s\u0590-\u05FF]+/g;
      
        // התאמת כל החלקים (עברית, רווחים, וחלקים אחרים) ושינוי רק את החלקים שאינם בעברית או רווחים
        return str.match(regex).map((part) => {
          // אם זה בעברית או רווח, משאירים אותו כפי שהוא
          return /[\u0590-\u05FF]|\s/.test(part) ? part : part.split('').reverse().join('');
        }).join('');
      };
      

      // תאריך עברי
      const hebrewDateString = (str) => {
        return (!isNaN(new Date(str))) ? hebrewDate(str) : ''
      }
      
      console.log(reverseNonHebrew("שלום 1234 עולם 5678"));

      const customerName = `${customer?.fullNameHe} ${reverseString(customer?.nom)}`;
      const graveName = (grave?.graveNameHe === '' || grave?.graveNameHe === grave?.areaGraveNameHe) ? 
        grave?.areaGraveNameHe : `${grave?.areaGraveNameHe}-${grave?.graveNameHe}`      

      const data = {
        serialNumber: purchase?.deedNum || '1234',
        name: customerName,
        numId: `${customer?.numId}`,
        address: reverseNonHebrew(`${customer?.address || ''} ${country?.countryNameHe || ''} ${city?.cityNameHe || ''}`),
        cemetery: reverseNonHebrew(grave?.cemeteryNameHe) || '',
        block: reverseNonHebrew(grave?.blockNameHe) || '',
        plot: reverseNonHebrew(grave?.plotNameHe) || '',
        row: reverseNonHebrew(grave?.lineNameHe) || '',
        grave: reverseNonHebrew(graveName),
        blockCode: reverseNonHebrew(block?.nationalInsuranceCode) || '',
        plotCode: reverseNonHebrew(plot?.nationalInsuranceCode) || '',
        purchaseNumber: purchase?.serialPurchaseId || '',
        deep: purchase?.deedNum || '',
        price: formatNumberWithCommas(purchase?.price),
        dataPurchase: purchase?.dateOpening || '',
        dataPurchaseHe: hebrewDateString(purchase?.dateOpening) || ''
      };

      const document = 'deep';

      console.log(1, data);
      

      docDeep(data, document, fileName);
    } else {
      setOpenCertificate(true)
    }
  };

  const documentsPurchases = [
    { id: 1, src: '../images/docConsular.png', fileName: 'אישור קונסולרי.pdf', handleClick: handleClickConsular, permissions: [1, 3] },
    { id: 2, src: '../images/docPurchase.png', fileName: 'טופס רכישה.pdf', handleClick: handleClickPurchase, permissions: [1, 3] },
    { id: 3, src: '../images/docDeep.png', fileName: 'שטר קבר.pdf', handleClick: handleClickDeep, permissions: [1] },
  ];

  const handleClickBurial = (id, fileName, setIsClicked) => {
    handleClick(setIsClicked);

    const data = {
      serialNumber: purchase?.serialPurchaseId || '1234',

      lastName: customer?.lastName,
      firstName: customer?.firstName,
      numId: customer?.numId,
      oldName: customer?.oldName,

      nameFather: customer?.nameFather,
      nameMother: customer?.nameMother,

      gender: customer?.gender,
      maritalStatus: customer?.maritalStatus,
      dateBirth: customer?.dateBirth,

      address: `${customer?.address} ${country?.countryNameHe} ${city?.cityNameHe}`,
      cemetery: grave?.cemeteryNameHe,
      block: grave?.blockNameHe,
      plot: grave?.plotNameHe,
      row: grave?.lineNameHe,

      grave: `${grave?.areaGraveNameHe}-${grave?.graveNameHe}`,
      deep: purchase?.serialPurchaseId,
    };

    const document = 'burial';
    docBurial(data, document, fileName);
  };

  const documentsBurials = [
    { id: 1, src: '../images/document.png', fileName: 'טופס קבורה.pdf', handleClick: handleClickBurial, permissions: [1, 2] },
    { id: 2, src: '../images/document.png', fileName: 'אישור קבורה.pdf', handleClick: handleClickDeep, permissions: [1, 3] },
  ];

  const menuItems = [
    {
      key: '1',
      label: 'מסמכי רכישה',
      disabled: !(purchaseContent && purchaseContent?.length > 0),
      content: <PageDocumentsGrave documents={documentsPurchases} />,
    },
    {
      key: '2',
      label: 'מסמכי קבורה',
      disabled: !(burialContent && burialContent?.length > 0),
      content: <PageDocumentsGrave documents={documentsBurials} />,
    },
    {
      key: '3',
      label: 'מסמכים כללים',
      content: <PageDocumentsGrave documents={[]} />,
    },
  ];

  return (
    <>
      <MyGenericComponent menuItems={menuItems} />

      <CustomDialog open={openCertificate} content={'content'}
        yes={'אישור'} onOk={true}
        handleClose={() => setOpenCertificate(false)}
        onAnswer={() => setOpenCertificate(false)} fullWidth={false} >
        <Typography>לא הונפק שטר</Typography>
      </CustomDialog>
    </>
  )
};

export default GraveDocuments;
